import JwtDecode from 'jwt-decode';
import Token from '../models/Token';

interface DecodeHelper {
  exp: number;
}

export default class TokenService {
  private static readonly TOKENS_ID: string = 'TOKENS';
  private static readonly SSO_ID: string = 'SSO';

  public static getToken(): Token | null {
    const tokensJsonString = localStorage.getItem(this.TOKENS_ID);

    if (!tokensJsonString || (tokensJsonString && tokensJsonString.length === 0)) {
      return null;
    }

    return JSON.parse(tokensJsonString);
  }

  public static setToken(tokens: Token): void {
    const { accessToken, refreshToken }: { accessToken: string; refreshToken: string } = tokens;

    if (!accessToken || !refreshToken) {
      throw Error('Tokens do not exists');
    }

    localStorage.setItem(this.TOKENS_ID, JSON.stringify(tokens));
  }

  public static removeToken(): void {
    localStorage.removeItem(this.TOKENS_ID);
  }

  public static isTokenValid(): boolean {
    const tokens: Token | null = JSON.parse(localStorage.getItem(this.TOKENS_ID) || '{}');

    if (!tokens || !Object.keys(tokens).length) {
      this.removeToken();
      return false;
    }

    const decodedToken: DecodeHelper = JwtDecode(tokens.accessToken);
    const expiredDate: number = decodedToken.exp;
    const now: number = Math.floor(Date.now() / 1000);

    if (expiredDate > now) {
      return true;
    }

    this.removeToken();
    return false;
  }

  public static wasSsoLogin() : boolean{
    const sso : string | null = localStorage.getItem(this.SSO_ID);

    return !!(sso && sso === 'true');
  }

  public static clearSsoLogin() : void{
    localStorage.removeItem(this.SSO_ID);
  }

  public static setSsoLogin() : void{
    localStorage.setItem(this.SSO_ID, "true");
  }

}
